import styled from 'styled-components'

import { WrapperMobileCss } from 'components/page/ForeignProfile/ForeignProfile.styled'

export const WrapperMobile = styled.div`
  ${WrapperMobileCss};
  margin: 30px 0;
`

export const WrapperMobileLast = styled.div`
  ${WrapperMobileCss};
  margin: 20px 0 10px;
`

export const Image = styled.img`
  width: 100%;
  object-fit: contain;
  object-position: center;
  border-radius: 10px;
  display: block;
`
